import {AppConfig} from '~/etc/env';


const appConfig: AppConfig = process.env.appConfig as unknown as AppConfig;

export default appConfig;
